import { IRestLayerRequest } from "@gtmhub/core";
import { IModalComponent } from "@gtmhub/core/routing";
import { IIndicator } from "@gtmhub/error-handling";
import { InsightboardService } from "@gtmhub/insightboards/services/dashboardService";
import { IInsight } from "@gtmhub/insights";
import { StateService } from "@uirouter/angularjs";
import { IComponentOptions, IController } from "angular";
import debounce from "lodash.debounce";

export interface IInsightboardDropdownItem {
  id: string;
  name: string;
  currentUserAllowedActions: string[];
}
export interface InsightDashboardSelectorBindings {
  selectedInsights: IInsight[];
}

/* eslint-disable @typescript-eslint/no-empty-interface */
export interface IInsightDashboardSelectorBindings extends IModalComponent<InsightDashboardSelectorBindings> {}
export interface InsightDashboardSelectorCtrl extends IInsightDashboardSelectorBindings {}

export class InsightDashboardSelectorCtrl implements IController {
  static $inject = ["$state", "InsightboardService"];
  insightboards: IInsightboardDropdownItem[];
  selectedInsightboard: IInsightboardDropdownItem;
  insights: IInsight[];
  indicators: {
    loading: IIndicator;
  };
  debouncedSearch: (searchValue: string) => void;
  insightboardFields = "id,name,currentUserAllowedActions";
  insightboardLimit = 30;
  insightboardSort = "-dateCreated";
  debounceWaitInMiliseconds = 500;

  constructor(private $state: StateService, private insightboardService: InsightboardService) {}

  $onInit() {
    this.debouncedSearch = debounce(this.filterInsightboardsByName, this.debounceWaitInMiliseconds);

    this.indicators = {
      loading: { progress: true },
    };
    const params: IRestLayerRequest = {
      fields: this.insightboardFields,
      sort: this.insightboardSort,
      limit: this.insightboardLimit,
    };

    this.insightboardService
      .getInsightboardsV2(params)
      .then((res) => {
        const dashboards = res.items as IInsightboardDropdownItem[];
        this.insightboards = dashboards.filter((dashboard) => dashboard.currentUserAllowedActions.indexOf("update") != -1);
        this.insights = this.resolve.selectedInsights;
        delete this.indicators.loading;
      })
      .catch((error) => {
        this.indicators.loading = { error };
      });
  }
  addSelectedInsights = () => {
    this.$state.go("gtmhub.insightboard", { dashboardId: this.selectedInsightboard.id, widgets: this.insights });
  };

  removeSelectedInsight = (insightId: string) => {
    this.insights = this.insights.filter((insight) => insight.id !== insightId);
    if (this.insights.length === 0) {
      this.close();
    }
  };

  filterInsightboardsByName = (searchValue: string): void => {
    this.indicators.loading = { progress: true };
    const params: IRestLayerRequest = {
      fields: this.insightboardFields,
      sort: this.insightboardSort,
      limit: this.insightboardLimit,
      filter: {
        name: { $regex: searchValue },
      },
    };
    this.insightboardService
      .getInsightboardsV2(params)
      .then((res) => {
        const dashboards = res.items as IInsightboardDropdownItem[];
        this.insightboards = dashboards.filter((dashboard) => dashboard.currentUserAllowedActions.indexOf("update") != -1);
        delete this.indicators.loading;
      })
      .catch((error) => (this.indicators.loading = { error }));
  };

  resetIndicator = () => {
    delete this.indicators.loading;
  };
}

export const InsightDashboardSelectorComponent: IComponentOptions = {
  controller: InsightDashboardSelectorCtrl,
  templateUrl: require("./insight-dashboard-selector.jade"),
  bindings: {
    resolve: "<",
    close: "&",
  },
};
